// TODO: resolve allowSyntheticDefaultImports in the unit tests and use
// import orderBy from "lodash/orderBy" form as to not import all
// of lodash.
import { orderBy, toNumber, isString } from "lodash";

interface SortKey {
  key: string;
  order: "asc" | "desc";
  valFn: Function;
}

export default class Sorter {
  private collection: any[];
  private sortKeys: SortKey[];

  constructor(collection: any[]) {
    this.collection = collection;
    this.sortKeys = [];
  }

  updateCollection(collection: any[]) {
    this.collection = collection;
  }

  getSortKeys() {
    return this.sortKeys;
  }

  setSortKey(key, fn = undefined) {
    for (let i = 0; i < this.sortKeys.length; i += 1) {
      if (this.sortKeys[i].key === key) {
        this.sortKeys[i].order = this.sortKeys[i].order === "asc" ? "desc" : "asc";
        return;
      }
    }

    const newSortKey: SortKey = {
      key,
      order: "asc",
      valFn: fn,
    };
    // append to end of list to set new sorts as primary
    this.sortKeys = this.sortKeys.concat([newSortKey]);
  }

  clearSortKey(sortKey) {
    let sortKeys = [];
    for (let i = 0; i < this.sortKeys.length; i += 1) {
      if (this.sortKeys[i].key !== sortKey) {
        sortKeys = sortKeys.concat(this.sortKeys[i]);
      }
    }
    this.sortKeys = sortKeys;
  }

  sortables() {
    let returnable = this.collection;
    for (let i = 0; i < this.sortKeys.length; i += 1) {
      returnable = orderBy(
        returnable,
        obj => {
          let value = obj[this.sortKeys[i].key];
          if (typeof this.sortKeys[i].valFn === "function") {
            value = this.sortKeys[i].valFn(obj);
          }
          if (value && (Number(value) || value === "0") && isString(value) && value !== "") {
            return toNumber(value);
          }

          if (isString(value)) {
            return value.toLowerCase();
          }

          return value;
        },
        this.sortKeys[i].order,
      );
    }
    return returnable;
  }
}
